import { getFirestore, getCloudStorage /*getFirestoreDeleteField  */, getFirestoreDeleteField } from '../../system/firebase';

import { COMPOSITE_DOC_ID_DELIMITER } from '../../system/constants';
import { removeFromDto } from '../dtoHelper';
import {
    SNACK_BAR_MESSAGE_OPERATION_FAILED,
    SNACK_BAR_MESSAGE_REPORT_THREAD,
    SNACK_BAR_MESSAGE_THREAD_FOLLOW_UP,
    SNACK_BAR_MESSAGE_THREAD_REMOVED_FOLLOW_UP,
    SNACK_BAR_MESSAGE_BLOCK_THREAD,
    SNACK_BAR_MESSAGE_DELETE_THREAD,
} from '../constants';
import { convertFirebaseTimestampsToDate } from '../dateHelper';

import { format as formatDate } from 'date-fns';

import _get from 'lodash/get';
// import _set from 'lodash/set';
import _map from 'lodash/map';
import _concat from 'lodash/concat';
import _filter from 'lodash/filter';

export const loadMyMessagesById = (id, setMyMessagesData) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const myMessagesRef = db.collection('myMessages').doc(id);

    try {
        return myMessagesRef.onSnapshot(myMessageDoc => {
            const data = myMessageDoc.data();

            setMyMessagesData({ myMessagesId: myMessageDoc.id, ...data });
        });
    } catch (error) {
        console.error('Failed to load myMessages data', error);
    }
};

export const loadThreadSummariesById = (id, setThreadSummaries) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const threadSummariesQuery = db.collection('myMessages').doc(id).collection('threadSummaries').where('active', '==', true).orderBy('lastMessageDt', 'desc'); //.limit(50);

    try {
        return threadSummariesQuery.onSnapshot(threadSummariesSnapshot => {
            const threadSummariesData = [];

            threadSummariesSnapshot.forEach(threadSummaryDoc => {
                const data = threadSummaryDoc.data();

                // map Google Timestamp to javascript Date
                threadSummariesData.push({
                    ...convertFirebaseTimestampsToDate(data, ['deleteDt', 'lastReadDt', 'lastMessageDt']),
                    threadId: threadSummaryDoc.id,
                });
            });

            setThreadSummaries(threadSummariesData);
        });
    } catch (error) {
        console.error('Failed to load thread summaries', error);
    }
};

export const loadThreadDetail = ({
    viewerId,
    // myMessagesId,
    threadId,
    setThreadData,
    // setReportedDt,
    // setMarkedForFollowUpDt,
    // setBlockedDt,
    // setMembers,
    setSnackbarErrorMessage,
}) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const threadsRef = db.collection('threads').doc(threadId);

    try {
        return threadsRef.onSnapshot(doc => {
            if (doc.exists) {
                let data = doc.data();

                // get the timestamps we are interested in
                const reportedDt = _get(data, `reportedDt.${viewerId}`, null);
                const followUpDt = _get(data, `followUpDt.${viewerId}`, null);
                const jobSeekerBlockedDt = _get(data, `blockedDt.jobSeeker`, null);
                const employerBlockedDt = _get(data, `blockedDt.employer`, null);

                // convert Firebase timestamps to javascript Dates
                const dateData = convertFirebaseTimestampsToDate({ reportedDt, followUpDt, jobSeekerBlockedDt, employerBlockedDt }, [
                    'reportedDt',
                    'followUpDt',
                    'jobSeekerBlockedDt',
                    'employerBlockedDt',
                ]);

                // for blockedDt, pick either the job seeker or employer blockedDt
                const blockedDt = _get(dateData, 'jobSeekerBlockedDt') || _get(dateData, 'employerBlockedDt');

                // set data
                setThreadData({ ...removeFromDto(data, ['jobSeekerBlockedDt', 'employerBlockedDt']), ...dateData, blockedDt });
            } else {
                setSnackbarErrorMessage('Thread does not exist.');
            }
        });
    } catch (error) {
        setSnackbarErrorMessage('Failed to load thread detail');
    }
};

export const loadThreadMessages = ({ viewerId, myMessagesId, threadId, deleteDt, internal, employerId, setThreadMessages, initPageAfterLoadMessages, setSnackbarErrorMessage }) => {
    const db = getFirestore();

    const messageSetsRef = db.collection('threads').doc(threadId).collection('messageSets');
    let messageSetsQuery = messageSetsRef.orderBy('lastMsgDt', 'desc');

    // if thread was deleted (but received new messages), fetch only the message sets with messages after the delete timestamp
    if (deleteDt) {
        messageSetsQuery = messageSetsRef.where('lastMsgDt', '>=', deleteDt).orderBy('lastMsgDt', 'desc');
    }

    try {
        return messageSetsQuery.onSnapshot(messageSetsSnapshot => {
            let threadMessages = [];

            messageSetsSnapshot.forEach(messageSetDoc => {
                const data = messageSetDoc.data();
                const messages = _get(data, 'messages', []);
                threadMessages = _concat(
                    _map(messages, message => convertFirebaseTimestampsToDate(message, ['createDt'])),
                    threadMessages,
                );
            });

            // filter out any messages sent before the delete timestamp
            const filteredMessages = deleteDt ? _filter(threadMessages, o => o.createDt >= deleteDt) : threadMessages;
            setThreadMessages(filteredMessages);
            if (initPageAfterLoadMessages) initPageAfterLoadMessages();

            // update the last read date
            const viewerDashboardId = internal ? `${viewerId}${COMPOSITE_DOC_ID_DELIMITER}${employerId}` : viewerId;
            updateThreadLastReadTimestamp({ viewerDashboardId, myMessagesId, threadId });
        });
    } catch (error) {
        setSnackbarErrorMessage('Failed to load thread detail');
    }
};

export const updateThreadLastReadTimestamp = async ({ viewerDashboardId, myMessagesId, threadId }) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const now = new Date();

    const threadSummaryRef = db.collection('myMessages').doc(myMessagesId).collection('threadSummaries').doc(threadId);

    const dashboardRef = db.collection('dashboards').doc(viewerDashboardId);

    try {
        await db.runTransaction(async transaction => {
            const threadSummaryDto = {
                lastReadDt: now,
                unreadCount: 0,
            };
            transaction.set(threadSummaryRef, threadSummaryDto, { merge: true });

            const dashboardDto = { unreadMsgsCounts: { [threadId]: 0 } };
            transaction.set(dashboardRef, dashboardDto, { merge: true });
        });
    } catch (error) {
        console.error('Last read timestamp transaction failed: ', error);
    }
};

export const addThreadMessage = async ({ messageDto, setSnackbarMessage, setSnackbarErrorMessage, recipientName = 'recipient', lastReadDtRef }) => {
    const db = getFirestore();

    try {
        const threadMessagesRef = db.collection('threadMessages');
        await threadMessagesRef.add(messageDto);
        if (lastReadDtRef) lastReadDtRef.current = new Date(); // renew ThreadDetail lastReadDtRef each time user sent a message
        setSnackbarMessage(`Sent to ${recipientName}`); // Do not implement Undo here!!!
    } catch (error) {
        console.error('Transaction failed when adding thread message:', error);
        setSnackbarErrorMessage('Failed to send message');
    }
};

export const reportThread = async ({ actionById, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmReportDialogOpen, setAnchorEl }) => {
    const db = getFirestore();

    const threadRef = db.collection('threads').doc(threadId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(threadRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                const data = doc.data();
                let reportedDt = _get(data, 'reportedDt', {});
                reportedDt[actionById] = new Date();
                transaction.update(threadRef, { reportedDt });
                setIsConfirmReportDialogOpen(false);
                setAnchorEl(null);
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_REPORT_THREAD);
        })
        .catch(function (error) {
            console.error('Report thread transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const markThreadForFollowUp = async ({ actionById, threadId, markedForFollowUpDt, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();

    //-------------------------------------------------------------------------------------------
    // prep for threads
    //-------------------------------------------------------------------------------------------
    const threadRef = db.collection('threads').doc(threadId);

    //-------------------------------------------------------------------------------------------
    // prep for myMessages > threadSummaries
    //-------------------------------------------------------------------------------------------
    const threadSummaryRef = db.collection('myMessages').doc(actionById).collection('threadSummaries').doc(threadId);

    try {
        // Get a new write batch
        const batch = db.batch();
        let snackbarMessageSuccessful = SNACK_BAR_MESSAGE_THREAD_REMOVED_FOLLOW_UP;

        //-------------------------------------------------------------------------------------------
        // write threads
        //-------------------------------------------------------------------------------------------
        // toggle the timestamp.  If not null, it was marked for follow up, so remove it.
        let newMarkedForFollowUpDt = null;
        if (!markedForFollowUpDt) {
            newMarkedForFollowUpDt = new Date();
            snackbarMessageSuccessful = SNACK_BAR_MESSAGE_THREAD_FOLLOW_UP;
        }

        // Update the thread document
        const threadDto = {
            followUpDt: { [actionById]: newMarkedForFollowUpDt },
        };
        batch.update(threadRef, threadDto);

        //-------------------------------------------------------------------------------------------
        // write myMessages > threadSummaries
        //-------------------------------------------------------------------------------------------
        // Update the thread summary
        const threadSummaryDto = {
            followUpDt: { [actionById]: newMarkedForFollowUpDt },
        };
        console.log('threadSummaryDto', threadSummaryDto);
        batch.update(threadSummaryRef, threadSummaryDto);

        await batch.commit();

        setSnackbarMessage(snackbarMessageSuccessful);
    } catch (error) {
        console.error('Mark for follow-up transaction failed: ', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const blockThread = async ({ isEmployer, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmBlockDialogOpen, setAnchorEl }) => {
    const db = getFirestore();

    const threadRef = db.collection('threads').doc(threadId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(threadRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                const data = doc.data();
                let blockedDt = _get(data, 'blockedDt', {});
                blockedDt[isEmployer ? 'employer' : 'jobSeeker'] = new Date();
                transaction.update(threadRef, { blockedDt });
                setIsConfirmBlockDialogOpen(false);
                setAnchorEl(null);
            });
        })
        .then(() => {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_BLOCK_THREAD);
        })
        .catch(error => {
            console.error('Block thread transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const sendFileReply = ({ file, userId, threadId, setProgress, setIsUploading, onAttachmentUploadComplete }) => {
    const storage = getCloudStorage();
    const name = _get(file, 'name');
    const timestampStr = formatDate(new Date(), 'yyyyMMddHHmmss_T');
    const storagePath = `users/${userId}/threads/${threadId}/${timestampStr}`;
    const uploadTask = storage.ref(`${storagePath}/${name}`).put(file, { customMetadata: { userId, threadId, key: timestampStr, originFilename: name, isMsgAttachment: true } });
    setIsUploading(true);
    uploadTask.on(
        'state_changed',
        snapshot => {
            // progress function ...
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress(progress);
        },
        error => {
            // Error function ...
            console.error('File upload failed', error);
        },
        async () => {
            // complete function ...
            try {
                const url = await storage.ref(storagePath).child(name).getDownloadURL();
                onAttachmentUploadComplete(file, url);
            } catch (error) {
                console.error('Failed to obtain file URL:', error);
            }
        },
    );
};

export const deleteThread = async ({
    actionById,
    threadId,
    internal,
    employerId,
    clearCurrentThread,
    setSnackbarMessage,
    setSnackbarErrorMessage,
    setIsConfirmDeleteDialogOpen,
    setAnchorEl,
}) => {
    const db = getFirestore();
    const now = new Date();

    //-------------------------------------------------------------------------------------------
    // prep for myMessages > threadSummaries
    //-------------------------------------------------------------------------------------------
    const threadSummaryRef = db.collection(`myMessages/${actionById}/threadSummaries`).doc(threadId);
    const threadSummaryDto = { active: getFirestoreDeleteField(), deleteDt: now };

    //-------------------------------------------------------------------------------------------
    // prep for dashboards
    //-------------------------------------------------------------------------------------------
    const dashboardId = internal ? `${actionById}${COMPOSITE_DOC_ID_DELIMITER}${employerId}` : actionById;
    const dashboardRef = db.collection('dashboards').doc(dashboardId);

    try {
        await db.runTransaction(async transaction => {
            //-------------------------------------------------------------------------------------------
            // read dashboards
            //-------------------------------------------------------------------------------------------
            const dashboardDoc = await transaction.get(dashboardRef);
            const unreadMsgsCounts = _get(dashboardDoc.data(), 'unreadMsgsCounts');
            delete unreadMsgsCounts[threadId];

            //-------------------------------------------------------------------------------------------
            // write myMessages > threadSummaries
            //-------------------------------------------------------------------------------------------
            transaction.set(threadSummaryRef, threadSummaryDto, { merge: true });

            //-------------------------------------------------------------------------------------------
            // write dashboards
            //-------------------------------------------------------------------------------------------
            transaction.update(dashboardRef, { unreadMsgsCounts });
        });

        setIsConfirmDeleteDialogOpen(false);
        setAnchorEl(null);
        clearCurrentThread(null);

        setSnackbarMessage(SNACK_BAR_MESSAGE_DELETE_THREAD);
    } catch (error) {
        setIsConfirmDeleteDialogOpen(false);
        setAnchorEl(null);

        console.error('Delete thread transaction failed: ', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};
